import { render } from "./MedicationView.vue?vue&type=template&id=bfd64884"
import script from "./MedicationView.vue?vue&type=script&lang=js"
export * from "./MedicationView.vue?vue&type=script&lang=js"

import "./MedicationView.vue?vue&type=style&index=0&id=bfd64884&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/orders/MedicationView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bfd64884"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bfd64884', __exports__)) {
    console.log('reload')
    api.reload('bfd64884', __exports__)
  }
  
  module.hot.accept("./MedicationView.vue?vue&type=template&id=bfd64884", () => {
    console.log('re-render')
    api.rerender('bfd64884', render)
  })

}


export default __exports__